import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/authStore'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/auth/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      name: 'dashboard',
      component: () => import('../views/dashboard/DashboardView.vue'),
    },
    {
      path: '/batch-requests',
      name: 'batchRequests',
      component: () => import('../views/batch-requests/BatchRequestList.vue'),
    },
    {
      path: '/batch-requests/new',
      name: 'batchRequestNew',
      component: () => import('../views/batch-requests/BatchRequestForm.vue'),
    },
    {
      path: '/batch-requests/:id',
      name: 'batchRequestDetail',
      component: () => import('../views/batch-requests/BatchRequestDetail.vue'),
    },
    {
      path: '/company-documents',
      name: 'companyDocuments',
      component: () => import('../views/dashboard/CompanyDocuments.vue'),
    },
    {
      path: '/chemical-products/new',
      name: 'newChemical',
      component: () => import('../views/chemicals/NewChemicalProductView.vue'),
    },
    {
      path: '/my-chemicals',
      name: 'myChemicals',
      component: () => import('../views/chemicals/MyChemicalSubmissionsView.vue'),
    },
    {
      path: '/storage-facilities/new',
      name: 'newStorageFacility',
      component: () => import('../views/storage-facilities/NewStorageFacilityView.vue'),
    },
    {
      path: '/my-storage-facilities',
      name: 'myStorageFacilities',
      component: () => import('../views/storage-facilities/MyStorageFacilitiesView.vue'),
    },
    {
      path: '/transfers',
      name: 'portalTransferList',
      component: () => import('../views/transfers/TransferList.vue'),
    },
    {
      path: '/transfers/new',
      name: 'portalTransferCreate',
      component: () => import('../views/transfers/TransferCreate.vue'),
    },
    {
      path: '/transfers/:id',
      name: 'portalTransferDetail',
      component: () => import('../views/transfers/TransferDetail.vue'),
    },
  ],
})

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  // Check authentication
  const isAuthenticated = await authStore.checkAuth()
  const isPublicRoute = to.meta.public === true

  if (!isPublicRoute && !isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } })
  } else if (isPublicRoute && isAuthenticated) {
    next({ name: 'dashboard' })
  } else {
    next()
  }
})

export default router
